/* Risk reversal en el drawer de Rebuy (Mau, 2026-08-18; diseño B de la
   maqueta "Garantía bajo el checkout").

   Pinta una línea con escudo justo DEBAJO del botón de pagar (desde la
   v14 estilizada como "labio": solapa pegada al botón, css-rebuy-cart),
   recordando la garantía que le corresponde a lo que hay en la cesta:

     Priority+ en la cesta ....... 100 días  (él es quien la amplía)
     Gel automático (= Protocolo Firmeza) ... 60 días
     Protocolo (6 o 12 meses) .....  60 días
     Dispositivo suelto / kit .....  30 días
     Ni dispositivo ni protocolo ... no se pinta nada

   El gel automático manda sobre el dispositivo: desde la v14 la tarjeta
   Protocolo añade skindion-rosa/negro (no protocolo-*), y lo que
   distingue su carrito es el dummy de la suscripción.

   v14 además: la línea de regalos («Tus 4 regalos van incluidos»)
   después del item del gel automático, dentro de la lista de productos
   (variante 1 de la maqueta "El cierre del drawer", Mau 2026-08-24).

   14b (Mau, 2026-08-24): textos del drawer en español de España. El
   idioma del Smart Cart vive en el admin de Rebuy y no se expone al
   theme, así que "Mi Carrito" → «Mi Cesta» y "Checkout" → «Finalizar
   pedido» se corrigen aquí sobre el DOM. El reemplazo solo actúa si
   encuentra el texto viejo exacto: si algún día se arregla en el admin
   de Rebuy, esto no hace nada (y entonces se puede borrar).

   La jerarquía importa: si llevan Protocolo Y Priority+, mandan los 100.
   Y si en la cesta solo hay geles o accesorios no hay garantía de
   resultados que prometer, así que la línea no aparece en vez de
   inventarse una.

   Sobre el DOM: la cesta es Rebuy (app), su HTML lo pinta Vue y lo
   re-renderiza a su antojo, pero NO usa shadow DOM. Por eso aquí hay un
   MutationObserver: cada vez que Rebuy repinta el footer volvemos a
   colocar la línea. La inserción es idempotente — si ya está, solo se
   actualiza el texto.

   El contenido de la cesta se lee de /cart.js (la fuente de verdad de
   Shopify, no los títulos del DOM, que cambian con el idioma). */
(function () {
  'use strict';

  var CLASE = 'skd-garantia';
  var ESCUDO =
    '<svg class="skd-garantia__escudo" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 3l7 3v5.5c0 4.4-2.9 7.9-7 9.5-4.1-1.6-7-5.1-7-9.5V6z"/>' +
    '<path d="M9 12.2l2.1 2.1L15.4 10"/></svg>';

  /* Handles, no IDs de variante: sobreviven a que Mau duplique variantes. */
  var PRIORITY = 'skindion-priority-plus';
  var GEL_AUTO = 'gel-conductor-hidratante-auto';
  var PROTOCOLO = /^protocolo-skindion/;
  var DISPOSITIVO = /(^skindion-(rosa|negro)$)|beauty-kit|^dispositivo-de-/;

  var NIVELES = {
    100: { texto: 'Garantía ampliada', dias: '100 días' },
    60:  { texto: 'Garantía de resultados', dias: '60 días' },
    30:  { texto: 'Devolución garantizada', dias: '30 días' }
  };

  var ultimoNivel = null;
  var ultimoGel = null;
  var pidiendo = false;

  /* Promesa del advertorial (Mau, 2026-08-24): quien llegó atribuido con
     ?ref=protocolofacial tiene 60 días elija lo que elija, también aquí.
     Solo se eleva el 30 del dispositivo/Starter; el 60 del Protocolo y
     el 100 de Priority+ no cambian. La cookie la escribe
     js-skindion-atribucion.js (14 días, la misma que taguea la orden). */
  function esDelAdvertorial() {
    var partes = ('; ' + document.cookie).split('; skd_ref=');
    if (partes.length !== 2) return false;
    var crudo = decodeURIComponent(partes.pop().split(';').shift() || '');
    return crudo.split('|')[0] === 'protocolofacial';
  }

  function nivelDe(items) {
    var nivel = 0;
    for (var i = 0; i < items.length; i++) {
      var h = (items[i].handle || '').toLowerCase();
      if (h === PRIORITY) return 100;              // gana siempre
      if (h === GEL_AUTO) nivel = Math.max(nivel, 60);
      else if (PROTOCOLO.test(h)) nivel = Math.max(nivel, 60);
      else if (DISPOSITIVO.test(h)) nivel = Math.max(nivel, 30);
    }
    if (nivel === 30 && esDelAdvertorial()) nivel = 60;
    return nivel;
  }
  /* La misma regla la usa el pop-up de Priority+ (js-priority-plus.js) para
     decir los días "Sin Priority+": una sola fuente de verdad para la cesta. */
  window.skdGarantiaNivel = nivelDe;

  function hayGelAuto(items) {
    for (var i = 0; i < items.length; i++) {
      if ((items[i].handle || '').toLowerCase() === GEL_AUTO) return true;
    }
    return false;
  }

  /* La línea de regalos: <li> verde tras el item del gel automático, dentro
     de la lista de productos. Solo existe si el carrito lleva el gel (= el
     Protocolo Firmeza). Idempotente, como la garantía. */
  function colocarRegalos(hay) {
    var item = document.querySelector('#rebuy-cart .rebuy-cart__flyout-item.product-' + GEL_AUTO);
    var linea = document.querySelector('#rebuy-cart .skd-regalos');
    if (!hay || !item) {
      if (linea) linea.remove();
      return;
    }
    if (!linea) {
      linea = document.createElement('li');
      linea.className = 'skd-regalos';
      linea.innerHTML = '<span class="skd-regalos__emoji" aria-hidden="true">🎁</span><span><strong>Tus 4 regalos van incluidos</strong></span>';
    }
    if (linea.previousElementSibling !== item) item.insertAdjacentElement('afterend', linea);
  }

  /* Español de España en el drawer (ver cabecera). Idempotente: escribe
     solo si el texto viejo sigue ahí, así el MutationObserver no entra
     en bucle (un no-op no dispara mutaciones). */
  function traducir() {
    var titulo = document.querySelector('#rebuy-cart .rebuy-cart__title');
    if (titulo && titulo.textContent.trim() === 'Mi Carrito') titulo.textContent = 'Mi Cesta';
    var btn = document.querySelector('#rebuy-cart .rebuy-cart__checkout-button');
    if (btn) {
      var objetivo = btn.querySelector('span') || btn;
      if (objetivo.textContent.trim() === 'Checkout') objetivo.textContent = 'Finalizar pedido';
    }
  }

  function colocar(nivel) {
    var btn = document.querySelector('#rebuy-cart .rebuy-cart__checkout-button');
    if (!btn) return;

    var linea = document.querySelector('#rebuy-cart .' + CLASE);

    if (!nivel) {
      if (linea) linea.remove();
      return;
    }

    if (!linea) {
      linea = document.createElement('p');
      linea.className = CLASE;
      linea.innerHTML = ESCUDO + '<span></span>';
    }

    var n = NIVELES[nivel];
    var span = linea.querySelector('span');
    /* Idempotente (auditoría 14k): reescribir el span en cada pasada
       disparaba al MutationObserver, que re-llamaba aquí, y el ciclo
       (con su fetch a /cart.js en refrescar) quedaba girando cada 120ms
       mientras el drawer existiera. Solo se escribe si cambió. */
    var objetivo = n.texto + ' ' + n.dias;
    if (span.textContent !== objetivo) {
      span.textContent = '';
      span.appendChild(document.createTextNode(n.texto + ' '));
      var fuerte = document.createElement('strong');
      fuerte.textContent = n.dias;
      span.appendChild(fuerte);
    }

    /* Justo después del botón: antes de las cuotas y de los logos de pago,
       que siguen cerrando el bloque como hasta ahora. */
    if (linea.previousElementSibling !== btn) btn.insertAdjacentElement('afterend', linea);
  }

  function refrescar() {
    if (pidiendo) return;
    pidiendo = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ultimoNivel = nivelDe(cart.items || []);
        ultimoGel = hayGelAuto(cart.items || []);
        colocar(ultimoNivel);
        colocarRegalos(ultimoGel);
        traducir();
      })
      .catch(function () {})
      .then(function () { pidiendo = false; });
  }

  /* Rebuy repinta: recolocamos con lo que ya sabíamos (sin pedir la cesta
     otra vez) y, en paralelo, refrescamos por si cambió el contenido. */
  var pendiente = null;
  function alRepintar() {
    if (pendiente) return;
    pendiente = setTimeout(function () {
      pendiente = null;
      if (ultimoNivel !== null) colocar(ultimoNivel);
      if (ultimoGel !== null) colocarRegalos(ultimoGel);
      traducir();
      refrescar();
    }, 120);
  }

  function arrancar() {
    var raiz = document.getElementById('rebuy-cart');
    if (!raiz) return false;
    /* Si el vigía del body arrancó primero, el evento rebuy:smartcart.ready
       volvía a llamar aquí y colgaba un SEGUNDO observer del mismo drawer
       (auditoría 2026-09-22). Una vez por contenedor. */
    if (raiz.__skdGarantia) return true;
    raiz.__skdGarantia = true;
    new MutationObserver(alRepintar).observe(raiz, { childList: true, subtree: true });
    refrescar();
    return true;
  }

  if (!arrancar()) {
    /* El contenedor de Rebuy aún no existe: se espera a su evento y, como
       red de seguridad, se vigila el body hasta que aparezca. */
    document.addEventListener('rebuy:smartcart.ready', arrancar);
    var vigia = new MutationObserver(function () {
      if (arrancar()) vigia.disconnect();
    });
    vigia.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('rebuy:cart.change', refrescar);
})();
